<template>
    <div class="My_popup">
        <div class="My_popup_wrap">
            <span class="My_popup_close"><a href="#" @click.prevent="closeClickHandler">닫기</a></span>
            <div class="My-popup-title"><span class="color-blue">{{ accidentInfo.accidentCategoryNm }}</span></div>
            <div class="traffic-map">
                <DrawRegionNaverMap />
            </div>
            <div class="My-popup-content">
                <div class="traffic-pop">
                    <div class="traffic-list">
                        <ul>
                            <li>
                                <span>발생일시</span>
                                <span class="color-red">{{ (accidentInfo.val5 + accidentInfo.val6) | formatDate('yyyy-MM-dd HH:mm') }}</span>
                            </li>
                            <li>
                                <span>종료일시</span>
                                <span class="color-red">{{ (accidentInfo.val7 + accidentInfo.val8) | formatDate('yyyy-MM-dd HH:mm') }}</span>
                            </li>
                            <li>
                                <span>사고내용</span>
                                <span>{{ accidentInfo.val4 }}</span>
                            </li>
                        </ul>
                    </div>              
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NaverMapMixin from "@/store/naver.map.local.mixin.js"
import DrawRegionNaverMap from "@/components/DrawRegionNaverMap.vue";

export default {
    name: 'AccidentInfoMapWin',
    data() {
        return {
            accidentMarkerKey: 'accidentMarker',
            trafficLayer: {},
        };
    },
    props: {
        accidentInfo: {
            type: Object,
            required: true
        }
    },
    created() {
        this.$eventBus.$once('NaverMap::map-loaded', map => {
            this.naverMaps = map;
            this.trafficLayer = new naver.maps.TrafficLayer({
                useStyleMap: true,
                interval: 1000 * 60 * 10 // 10분마다 갱신
            });
            this.trafficLayer.setMap(map);
        });
        
        this.$eventBus.$once("DrawRegionNaverMap::completed-draw-region", geoJsonDrawing => {
            this.geoJsonDrawing = geoJsonDrawing;
            this.placeMarker();
        });
    },
    methods: {
        closeClickHandler() {
            this.$emit("close-accident-info-map-win");
        },
        placeMarker() {
            if(this.accidentInfo.lttdVal && this.accidentInfo.lgtdVal) {
                let position = new naver.maps.LatLng(this.accidentInfo.lttdVal, this.accidentInfo.lgtdVal);
                this.naverMaps.setCenter(position);
                let markerImgName = 'marker_activeAccident_' + this.accidentInfo.accidentCategoryCd + '.png';
                let marker = this.makeMarker(this.accidentMarkerKey, this.accidentInfo, () => {}, markerImgName, 'images/marker/', 28, 35);
                this.showMarkers(this.accidentMarkerKey, true);
            }
        },
    },
    mixins: [NaverMapMixin],
    components: {
        DrawRegionNaverMap
    },
}
</script>